<template>
  <div>
      <ShortCut></ShortCut>
      <LogoHome></LogoHome>
      <Navigation></Navigation>
          <!---->
        <el-carousel indicator-position="outside" :height="bannerHeight + 'px'">
          <el-carousel-item v-for="(item,index) in imgList" :key="index">
            <img :src="item" />
          </el-carousel-item>
        </el-carousel>
      <Notice></Notice>
  </div>
</template>




<script>
import ShortCut from '../component/ShortCut'
import LogoHome from '../component/LogoHome'
import Navigation from '../component/Navigation'
import Notice from "../component/Notice";
export default {
  components:{
    Notice,
    ShortCut,
    LogoHome,
    Navigation
  },
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1',
      imgList:[
        require("../image/banner1.png"),
        require("../image/banner2.png"),
        require("../image/banner3.png")
      ],
      // 图片父容器高度
      bannerHeight: 1500,
      // 浏览器宽度
      screenWidth: 0

    };

  },
  methods: {
    setSize: function() {
      // 通过浏览器宽度(图片宽度)计算高度
      this.bannerHeight = (500 / 1920) * this.screenWidth;
    },
  },
  mounted() {
    // 首次加载时,需要调用一次
    this.screenWidth = window.innerWidth;
    this.setSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setSize();
    };
  }
}
</script>

<style ang="less" scoped>
img {
  /*设置图片宽度和浏览器宽度一致*/
  width: 80%;
  height: inherit;
}
</style>

<style>

</style>



// WEBPACK FOOTER //
// src/components/home/home.vue